export default defineNuxtRouteMiddleware((to, from) => {
  if (import.meta.client && to.path !== from.path) {
    if (to.hash) {
      const scrollToHash = (attempts = 0) => {
        const element = document.querySelector(to.hash);
        console.log(`Attempt ${attempts + 1}: Element found:`, element, "for hash:", to.hash);

        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        } else if (attempts < 10) {
          setTimeout(() => scrollToHash(attempts + 1), 200);
        } else {
          console.log("Element not found after all attempts, scrolling to top");
          window.scrollTo({ top: 0, behavior: "smooth" });
        }
      };

      scrollToHash();
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }
});
